import { Divider, Grid, Typography } from "@material-ui/core";
import React, { useLayoutEffect, useState } from "react";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import "../../style.css";
import { useTranslation } from "react-i18next";
import Config from "../../../../config";
import { APP_LANG } from "../../../../config/constant";

const { SUBSCRIPTION_RENEWAL_DISCOUNT_PERCENTAGE } = Config;

const PaymentOption = ({
  id,
  title,
  description,
  checkoutAmount,
  action,
  isRecurring,
  minCardHeight,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <Grid
      id={id}
      container
      direction="row"
      alignItems="center"
      className="payment-option-card"
      onClick={typeof action === "function" && action}
      wrap="nowrap"
      style={{ minHeight: minCardHeight }}
    >
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        className="option-content"
      >
        <Typography
          variant="body2"
          className={`plan-txt-color font-weight-600 ${
            i18n.language === APP_LANG.SI && "body-2-si"
          }`}
        >
          {title}
        </Typography>
        <Typography
          variant="caption"
          className={`plan-txt-color text-center ${
            i18n.language === APP_LANG.SI && "caption-si"
          }`}
        >
          {description}
        </Typography>
        <Grid container direction="column" alignItems="center">
          {/* <Typography
            variant="body2"
            className="plan-txt-color font-weight-600 text-center"
          >
            {checkoutAmount}
          </Typography> */}
          {isRecurring && (
            <Typography
              variant="caption"
              className={`plan-txt-color font-weight-600 text-center ${
                i18n.language === APP_LANG.SI && "caption-si"
              }`}
            >
              {t("payment.subscriptionRenewalDiscount", {
                discount: SUBSCRIPTION_RENEWAL_DISCOUNT_PERCENTAGE,
              })}
            </Typography>
          )}
        </Grid>
      </Grid>
      <NavigateNextIcon />
    </Grid>
  );
};

const PaymentOptions = ({
  packageAmount,
  packageDuration,
  currency,
  onClickPaymentOption,
  onClickCancel,
}) => {
  const { t } = useTranslation();
  const [minCardHeight, setMinCardHeight] = useState(0);

  const checkoutAmount = `${currency} ${packageAmount.toLocaleString(
    undefined,
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  )}`;

  useLayoutEffect(() => {
    const subscriptionCard = document.getElementById(
      "subscription-option-card"
    );
    const oneTimeCard = document.getElementById("one-time-option-card");

    if (subscriptionCard && oneTimeCard) {
      const newHeight = Math.max(
        subscriptionCard.clientHeight,
        oneTimeCard.clientHeight
      );
      setMinCardHeight(newHeight);
    }
  }, [t]);

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      className="payment-options-container"
    >
      <Typography variant="body2" className="paymment-options-title">
        {t("payment.selectPaymentOption")}
      </Typography>
      <Divider className="paymment-options-divider" />
      <PaymentOption
        id="subscription-option-card"
        title={t("payment.subscriptionPlan")}
        description={t("payment.subscriptionInfo")}
        checkoutAmount={checkoutAmount}
        isRecurring={true}
        action={() => onClickPaymentOption({ isRecurringPayment: true })}
        packageDuration={packageDuration}
        minCardHeight={minCardHeight}
      />
      <PaymentOption
        id="one-time-option-card"
        title={t("payment.oneTimePayment")}
        description={t("payment.oneTimePaymentInfo")}
        checkoutAmount={checkoutAmount}
        action={() => onClickPaymentOption({ isRecurringPayment: false })}
        packageDuration={packageDuration}
        minCardHeight={minCardHeight}
      />
      <Typography
        className="payment-options-cancel-link"
        onClick={onClickCancel}
      >
        Cancel
      </Typography>
    </Grid>
  );
};

export default PaymentOptions;
